import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect, Suspense } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

interface AppRoutesProps {
  darkMode: boolean;
}

export function AppRoutes({ darkMode }: AppRoutesProps) {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  }, [navigate]);
  
  return (
    <Suspense
      fallback={
        <div className={`flex items-center justify-center min-h-screen ${darkMode ? 'bg-gray-950' : 'bg-white'}`}>
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-cyan-500"></div>
        </div>
      }
    >
      {element}
    </Suspense>
  );
}
